// Module AUTOGENERATED by translations
// See translations/README.md
import { unsafeMakeTranslationKeysProxy } from "../TranslationKeys";
export const t = unsafeMakeTranslationKeysProxy("");
